import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_COLLATERAL_SCHEDULE_Mapper extends BaseFormMapper<BMO_COLLATERAL_SCHEDULE> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_COLLATERAL_SCHEDULE,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_COLLATERAL_SCHEDULE);

		return _formData;
	}

	MapValues(): Partial<BMO_COLLATERAL_SCHEDULE> {
		return {};
	}
}

const Mappings: BMO_COLLATERAL_SCHEDULE = {
	filmed: 'Filmed',
	abstracted: 'Abstracted',
	verified: 'VerifiedCertified',
	registered: 'RegisteredReceived',
	oldCreditBaseRate3: 'per annum calculated halfyearly not in advance',
	oldCreditBaseRate2: 'per annum calculated monthly not in advance',
	oldCreditBaseRate: 'per annum calculated monthly not in advance Therefore on',
	dateYear: 'the Chargees Personal Line of',
	dateMonth: 'year',
	dateDay: 'day of',
	creditBaseRate: 'per annum in excess of the',
};

export interface BMO_COLLATERAL_SCHEDULE {
	creditBaseRate: string;
	dateDay: string;
	dateMonth: string;
	dateYear: string;
	oldCreditBaseRate: string;
	oldCreditBaseRate2: string;
	oldCreditBaseRate3: string;

	registered: string;
	verified: string;
	abstracted: string;
	filmed: string;
}
